import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useLocale } from '../contexts/LocaleContext';
import { hardwareFirstTrialRecurringCharge } from '../lib/hardwareFirst';
import { getLocalizedPricing } from '../lib/util/money';
import * as types from '../types';
import useHardwareFirstTrialUnits from './useHardwareFirstTrialUnits';

/**
 * The membership a hardware-first trial cart bills after the trial, for the wallet sheet to disclose. The
 * server prices no recurring charge for it, so it comes from the published membership terms.
 * Undefined when the cart holds no trial.
 */
export default function useHardwareFirstTrialRecurringCharge(): types.HardwareFirstRecurringCharge | undefined {
  const { count } = useHardwareFirstTrialUnits();
  const { currency } = useLocale();
  const terms = useSelector((state: types.AppState) => state.config.siteConfig.hardwareFirstMembershipTerms);
  // the start date is fixed at mount so the sheet's options do not change on every render
  const orderedAt = useMemo(() => new Date(), []);

  return useMemo(
    () =>
      count > 0
        ? hardwareFirstTrialRecurringCharge(terms, (pricing) => getLocalizedPricing(pricing, currency), orderedAt)
        : undefined,
    [count, terms, currency, orderedAt],
  );
}
